import './styles.scss'
import '../../../../components/Marketing/Templates/styles.scss'
import React, { useState } from 'react'
import { withRouter } from 'react-router-dom'
import queryString from 'query-string'
import { connect } from 'react-redux'
import { Container, Col, Row } from 'reactstrap'

import { MARKETING } from '../../../../constants'
import { TemplateFacebook, TemplateInstagram, TemplateWhatsApp, TemplateSms, TemplateTelegram, TemplateChatmail } from 'components/Marketing/Campaigns/index'
import TemplateWall from 'components/Marketing/Templates/TemplateWall'

const Templates = ({ history, location }) => {
  const { search, pathname } = location

  const geFormTemplate = () => {
    const queryParams = queryString.parse(search)
    const queryParamFormTemplate = queryParams.formTemplate
    return queryParamFormTemplate && Object.keys(MARKETING.channels).includes(queryParamFormTemplate)
      ? queryParamFormTemplate
      : pathname !== '/dashboard/conversations/templates' ? MARKETING.channels.chatmail : MARKETING.channels.whatsapp
  }

  const [formTemplate, setFormTemplate] = useState(geFormTemplate())

  const setActiveTemplate = (nextStep) => {
    history.push({ search: `?formTemplate=${nextStep}` })
    setFormTemplate(nextStep)
  }

  const getCurrentFormTemplate = (formTemplate) => {
    const options = {
      instagram: <TemplateInstagram setActiveTemplate={setActiveTemplate} templateOptions={MARKETING.channels} currentTemplate={formTemplate} />,
      facebook: <TemplateFacebook setActiveTemplate={setActiveTemplate} templateOptions={MARKETING.channels} currentTemplate={formTemplate} />,
      whatsapp: <TemplateWhatsApp setActiveTemplate={setActiveTemplate} templateOptions={MARKETING.channels} currentTemplate={formTemplate} />,
      sms: <TemplateSms setActiveTemplate={setActiveTemplate} templateOptions={MARKETING.channels} currentTemplate={formTemplate} />,
      telegram: <TemplateTelegram setActiveTemplate={setActiveTemplate} templateOptions={MARKETING.channels} currentTemplate={formTemplate} />,
      chatmail: <TemplateChatmail key='chatmail' setActiveTemplate={setActiveTemplate} templateOptions={MARKETING.channels} currentTemplate={formTemplate} />,
      chatweb: <TemplateWall key='chatweb' setActiveTemplate={setActiveTemplate} templateOptions={MARKETING.channels} currentTemplate={formTemplate} />,
      android: <TemplateWall key='android' setActiveTemplate={setActiveTemplate} templateOptions={MARKETING.channels} currentTemplate={formTemplate} />,
      ios: <TemplateWall key='ios' setActiveTemplate={setActiveTemplate} templateOptions={MARKETING.channels} currentTemplate={formTemplate} />,
      whatsapp_whatsapp: <TemplateWhatsApp setActiveTemplate={setActiveTemplate} templateOptions={MARKETING.channels} currentTemplate={formTemplate} />
    }

    return options[formTemplate]
  }

  return (
    <Row className='animated fadeIn'>
      <Col>
        <Container className='py-5 create-campaign' fluid>
          <Row className='template-wrapper'>
            <Col>
              <Row>
                <Col>{getCurrentFormTemplate(formTemplate)}</Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </Col>
    </Row>
  )
}

export default connect()(withRouter(Templates))
